/**
 * Resposta do servidor ao criar um novo pedido
 */
export type SuccessOrError = "success" | "error" | string;
export enum SuccessOrErrorEnum {
  SUCCESS = "success",
  ERROR = "error",
}

export enum AtemStatusEnum {
  LIB = "LIB",
  BL = "BL",
  ERROR = "error",
}

export type TypePayment = "T" | "B" | string;
export enum TypePaymentEnum {
  TRANSFER = "T",
  TICKET = "B",
}

export interface ICreateOrderDataDTO {
  status: SuccessOrError;
  response: ICreateOrderResponseItemDTO[];
}

export interface ICreateOrderResponseItemDTO {
  status: SuccessOrError;
  product: {
    id: string;
    deadlinePayment: number;
    payment: TypePayment;
    quantity: number;
    price?: number;
  };

  // Campos opcionais: só aparecem em caso de SUCESSO
  numberOrder?: string;
  atemStatus?: string;
  deliveryDate?: string;
  implantationDate?: string;

  // Campo opcional: só aparece em caso de ERRO
  error?: string;
}
